import React, { useEffect, useState } from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import { useSelector } from "react-redux";
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import CircularLoading from "../components/CircularLoading";

function matchUser(permit, profile){
    let permitions = permit? permit.split(',') : [];
    let permitted = false;
    const usertype = profile && profile.usertype ? profile.usertype : null;
    const capabilities = profile && profile.serviceCapabilities ? profile.serviceCapabilities : {};
    for(let i=0;i<permitions.length;i++){
        permitted = usertype === permitions[i] || capabilities[permitions[i]] === true ? true:false
        if(permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit,children }) {
    const auth = useSelector(state => state.auth);
    const location = useLocation();
    const [checkedAuth,setCheckedAuth] = useState(false);

    useEffect(()=>{
        if(auth.profile && auth.profile.uid){
            setCheckedAuth(true);
        }
        if(auth.error && auth.error.msg && !auth.profile){
            setCheckedAuth(true);
        }
    },[auth.profile,auth.error])

    return(
        checkedAuth?
            auth.profile && auth.profile.uid?
                matchUser(permit,auth.profile) ? <ResponsiveDrawer>{children}</ResponsiveDrawer>:<Navigate to="/login" replace state={{ redirectTo: location.pathname + location.search }} />
            :<Navigate to="/login" replace state={{ redirectTo: location.pathname + location.search }} />
        :<CircularLoading/>
    )
}

export default ProtectedRoute;